<template>
  <vs-row vs-justify="center" vs-align="center" :class="fullheight" id="create-box">
    <vs-col type="flex" vs-lg="12" vs-xs="12">
      <vs-card id="form" fixedHeight :before-change="validateCreateForm">
          <vs-row class="mt-4">
              <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
                  <vs-row>
                    <vs-col vs-w="6" vs-xs="12">
                      <vs-input icon-after="true" size="medium" class="w-100 mb-2 mt-2 vs-input-medium col-md-8 offset-md-2"
                                :danger="errors.companyName" :danger-text="$t('Errors.InvalidPolite', {field: $t('Company.Name')})"
                                icon="home" :placeholder="$t('Company.Name')" v-model="companyName" type="text"/>
                    </vs-col>
                    <vs-col vs-w="6" vs-xs="12">
                      <vs-input icon-after="true" size="medium" class="w-100 mb-2 mt-2 vs-input-medium col-md-8 offset-md-2"
                        :danger="errors.address" :danger-text="$t('Errors.InvalidPolite', {field: $t('Company.Address')})"
                        icon="home" :placeholder="$t('Company.Address')" v-model="address" type="text"/>
                    </vs-col>
                  </vs-row>
                  <vs-row>
                    <vs-col vs-w="6" vs-xs="12">
                      <vs-input icon-after="true" size="medium" class="w-100 mb-2 mt-2 vs-input-medium col-md-8 offset-md-2"
                                :danger="errors.phone" :danger-text="$t('Errors.InvalidPolite', {field: $t('Company.Phone')})"
                                icon="home" :placeholder="$t('Company.PhoneNumber')" v-model="phone" type="text"/>
                    </vs-col>
                   
                    <vs-col vs-w="3" vs-xs="12">
                      <vs-select
                        class="w-100 mt-2 col-md-8 offset-md-4"
                        :placeholder="$t('Company.Country')"
                        v-model="country"
                        @change="updateCities"
                        :danger="errors.country"  :danger-text="$t('Errors.InvalidSelectPolite', {field: $t('Company.Country')})"
                        >
                        <vs-select-item :key="index" :value="index" :text="index" v-for="(item,index) in countries"/>
                      </vs-select>
                    </vs-col>
                    <vs-col vs-w="3" vs-xs="12">
                      <vs-select
                          class="w-100 mt-2 col-md-8"
                          :placeholder="$t('Company.City')"
                          v-model="city"
                          :danger="errors.city"  :danger-text="$t('Errors.InvalidSelectPolite', {field: $t('Company.City')})"
                      >
                        <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in cities" />
                      </vs-select>
                    </vs-col>
                    
                  </vs-row>
                  <vs-row>
                    <vs-col vs-w="6" vs-xs="12">
                      <vs-input icon-after="true" size="medium" class="w-100 mb-2 mt-2 vs-input-medium col-md-8 offset-md-2"
                                :danger="errors.email" :danger-text="$t('Errors.InvalidPolite', {field: $t('Company.Email')})"
                                icon="email " :placeholder="$t('Company.Email')" v-model="email" type="text"/>
                    </vs-col>
                    
                    <vs-col vs-w="6" vs-xs="12">   
                      <vs-input icon-after="true" size="medium" class="w-100 mb-2 mt-2 vs-input-medium col-md-8 offset-md-2"
                        :danger="errors.postalCode" :danger-text="$t('Errors.InvalidPolite', {field: $t('Company.PostalCode')})"
                        icon="home" :placeholder="$t('Company.Password')" v-model="password" type="text"/>
                    </vs-col>
                    
                  </vs-row>

                  <vs-row>
                    <vs-col vs-w="6" vs-xs="12">   
                      <vs-input icon-after="true" size="medium" class="w-100 mb-2 mt-2 vs-input-medium col-md-8 offset-md-2"
                        :danger="errors.postalCode" :danger-text="$t('Errors.InvalidPolite', {field: $t('Company.PostalCode')})"
                        icon="home" :placeholder="$t('Company.PostalCode')" v-model="postalCode" type="text"/>
                    </vs-col>

                    <vs-col vs-w="3">
                          <vs-select
                                  class="w-100 mb-2 mt-2 col-md-8 offset-md-4"
                                  size="large"
                                  @change="loadSubIndustries(),loadServices()"
                                  
                                  :placeholder="$t('Company.Industry')"
                                  v-model="industry"
                                  :danger="errors.industry"  :danger-text="$t('Errors.InvalidSelectPolite', {field: $t('Company.Industry')})"
                          >
                              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in industries" />
                          </vs-select>
                      </vs-col>
                      <vs-col vs-w="3" class="offset-md-2" >
                          <vs-select
                                  class="w-100 mb-2 mt-2 col-md-8"
                                  size="large"
                                  :placeholder="$t('Company.SubIndustry')"
                                  @change="loadServices()"
                                  v-model="subIndustry"
                                  :danger="errors.subIndustry"  :danger-text="$t('Errors.InvalidSelectPolite', {field: $t('Company.SubIndustry')})"
                          >
                              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in subIndustries" />
                          </vs-select>
                      </vs-col>
                  </vs-row>
                  <vs-row>
                    <vs-col vs-w="6" vs-xs="12">   
                      <vs-input icon-after="true" size="medium" class="w-100 mb-2 mt-2 vs-input-medium col-md-8 offset-md-2"
                        :danger="errors.postalCode" :danger-text="$t('Errors.InvalidPolite', {field: $t('Company.PostalCode')})"
                        icon="home" :placeholder="$t('FName')" v-model="fName" type="text"/>
                    </vs-col>
                    <vs-col vs-w="6" vs-xs="12">   
                      <vs-input icon-after="true" size="medium" class="w-100 mb-2 mt-2 vs-input-medium col-md-8 offset-md-2"
                        :danger="errors.postalCode" :danger-text="$t('Errors.InvalidPolite', {field: $t('Company.PostalCode')})"
                        icon="home" :placeholder="$t('Lname')" v-model="lName" type="text"/>
                    </vs-col>
                  </vs-row>
                  <vs-row>
                     
                    
                    <vs-col vs-w="6" vs-xs="12">
                      <vs-input type="file" size="medium" class="w-100 mb-2 mt-2 vs-input-medium col-md-8 offset-md-2" id="fileInput"
                        :danger="errors.photo"  :danger-text="$t('Errors.InvalidFilePolite', {field: $t('Company.Logo')})"
                        v-model="photo"/>
                    </vs-col>
                      <vs-col vs-w="3" class="offset-md-2" >
                          <vs-select
                                  class="w-100 mb-2 mt-2 col-md-8"
                                  size="large"
                                  :placeholder="$t('Company.Services')"
                                  multiple
                                  v-model="services"
                                  :danger="errors.subIndustry"  :danger-text="$t('Errors.InvalidSelectPolite', {field: $t('Company.SubIndustry')})"
                          >
                              <vs-select-item :key="index" :value="item.id" :text="item.title" v-for="(item,index) in services_array" />
                          </vs-select>
                      </vs-col>
                  </vs-row>
                </vs-col>
              </vs-row>
              <br>
              <vs-row>
                <GmapMap 
                      class="col-md-10 offset-md-1"
                      :center="currentLocation"
                      :zoom="12"
                      map-type-id="terrain"
                      style="width: 500px; height: 300px"
                      :options="{
                        zoomControl: true,
                        mapTypeControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: true,
                        disableDefaultUi: false
                      }"
                >
                  <GmapMarker
                          :position="marker"
                          :clickable="true"
                          :draggable="true"
                          @dragend="updateCoordinates"
                  />
                </GmapMap>
              </vs-row>
              <br>
              <vs-row>
                  <p class="col-md-10 offset-md-1">{{$t('Auth.RegisterTermsIntro')}}
                      <router-link  target="_blank" to="/terms"> {{$t('Terms')}}</router-link> {{$t('Auth.RegisterTermsIntroAnd')}}
                      <router-link  target="_blank" to="/privacy"> {{$t('Privacy')}}</router-link>.</p>
              </vs-row>
              <vs-row>
                  <div class="col-md-10 offset-md-1">
                      <vs-checkbox v-model="terms" class="float-left">
                          {{$t('Auth.AcceptTerms')}}
                      </vs-checkbox>
                      <vs-alert v-if="errors.terms" class="mb-3 mt-2"  color="danger">
                          <b>{{$t('Errors.RegisterTermsFail')}}</b>
                      </vs-alert>
                  </div>
              </vs-row>
              <vs-row>
                  <div class="col-md-10 offset-md-1 mt-4">
                      <vs-button  class="float-right" color="primary" @click="createBusiness">{{$t('Company.CreateButton')}}</vs-button>
                  </div>
              </vs-row>
          </vs-card>
        </vs-col>
      </vs-row>
</template>

<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { helpersService, userService, businessService,servicesService } from '../../_services'
import {gmapApi} from 'vue2-google-maps'
import { mapActions } from 'vuex'
import VsPrism from '../../components/prism/VsPrism.vue';

export default {
  name: 'create-business-box',
  data:()=>({
    msg: "Create",
    firstname:'',
    lastname:'',
    fName: '',
    lName: '',
    email:'',
    pwd:'',
    companyName:'',
    phone:'',
    address:'',
    services: [],
    services_array: [],
    postalCode:'',
    industry:'',
    subIndustry:'',
    password: '',
    country:'',
    city:'',
    photo:'',
    terms: false,
    errors: {
      firstname: false,
      lastname: false,
      email: false,
      phone: false,
      pwd: false,
      companyName: false,
      industry: false,
      subIndustry: false,
      country: false,
      city: false,
      photo: false,
      address: false,
      postalCode: false,
      terms: false
    },
    industries: [],
    rawIndustries: [],
    subIndustries: [],
    countries: [],
    cities: [],
    marker: {lat: 36.8065, lng: 10.1815},
    currentLocation : {lat: 36.8065, lng: 10.1815},
  }),
  methods:{
    ...mapActions('account', ['register']),
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    checkForm:function(e) {
      this.errors = [];
      if(!this.email) {
        this.errors.push("Email required.");
      } else if(!this.validEmail(this.email)) {
        this.errors.push("Valid email required.");        
      }
      if(!this.firstname) this.errors.push("Firstname required.");
      if(!this.lastname) this.errors.push("Lastname required.");
      if(!this.pwd) this.errors.push("Password required.");
      if(!this.errors.length) return true;
      e.preventDefault();
    },
    /* eslint-disable */
    validEmail:function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
    },
    /* eslint-enable */

    geolocation : function() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.marker = this.currentLocation;
      });
    },
    loadServices(){
      let body = { industry : this.industry, subindustry: this.subIndustry}
      servicesService.getByIndustry(body).then( function (data){
        this.services_array = data.service.services;
      }.bind(this))
    },

    updateCoordinates(location) {
      this.marker = { lat: location.latLng.lat(), lng: location.latLng.lng() };
    },

    createBusiness(){
      this.$vs.loading({
        container: '#create-box',
        scale: 0.6
      });
      try{
        let business = new FormData()
        business.append('fname',this.fName);
        business.append('lname',this.lName);
        business.append('name',this.companyName);
        business.append('email',this.email);
        business.append('industry',this.industry.toString());
        business.append('subindustry',this.subIndustry.toString());
        business.append('phone',this.phone);
        business.append('address', this.address);
        business.append('postal_code', this.postalCode);
        business.append('country', this.country);
        business.append('city', this.city);
        business.append('lat', this.marker.lat);
        business.append('lng', this.marker.lng);
        business.append('password', this.password);
        business.append('services',this.services.join());
        if(document.getElementById("fileInput").files[0]){
        business.append('photo', document.getElementById("fileInput").files[0]);
      }

        businessService.create(business).then( function (){
          this.$vs.loading.close('#create-box > .con-vs-loading');
          this.notify(
                  this.$t("Toasts.Successful"),
                  this.$t("Businesses.CreateBusinessVue.ToastSuccessMessage"),
                  "success"
                );
          this.$router.back();
          }.bind(this)).catch(function () {
            this.$vs.loading.close('#create-box > .con-vs-loading');
        this.notify(
                  this.$t("Toasts.Error"),
                  this.$t("Businesses.CreateBusinessVue.ToastFailMessage"),
                  "danger"
                );
        }.bind(this)).finally(function () {
          
        }.bind(this));
      } catch (e) {
        this.$vs.loading.close('#create-box > .con-vs-loading');
        this.notify(
                  this.$t("Toasts.Error"),
                  this.$t("Businesses.CreateBusinessVue.ToastFailMessage"),
                  "danger"
                );
      }
    },

    async validateCreateForm() {
      let valid = false;
      let availableEmail = await this.availableEmail(this.email);
      this.errors.email = (!this.validEmail(this.email) || !availableEmail) ? true : false;
      this.errors.companyName = (this.companyName.length < 5) ? true : false;
      this.errors.industry = (this.industry == '') ? true : false;
      this.errors.country = (this.country == '') ? true : false;
      this.errors.city = (this.city == '') ? true : false;
      this.errors.address = (this.address.length < 5) ? true : false;
      this.errors.postalCode = (this.postalCode == '') ? true : false;
      valid = !(this.errors.firstname || this.errors.lastname || this.errors.pwd || this.errors.email || this.errors.companyName || this.errors.industry || this.errors.country || this.errors.city || this.errors.photo || this.errors.address || this.errors.postalCode);
      return valid;
    },

    async availableEmail(email){
      let available = false;
      await userService.checkEmail(email).then(function (data) {
        available = !data.exists;
      }).catch(function() {
        available = false;
      });
      return available;
    },
    
    updateCities(){
      this.city = '';
      this.cities = this.countries[this.country];
    },
    loadSubIndustries(){
        this.subIndustry=null;
        let selectedIndustry = this.rawIndustries.find(function (obj) {
           return obj.id == this.industry;
        }.bind(this));

        this.subIndustries = [];
        selectedIndustry.sub_industries.forEach(obj => {
            this.subIndustries.push({
                value: obj.id,
                text: obj.title
            });
        });
    }
  },  
  computed: {
    inputValid(){
      if(this.validEmail(this.email) && this.pwd && this.firstname && this.lastname){
        return false
      } else {
        return true
      }
    },
    google: gmapApi,
    authClass(){
      return process.env.VUE_APP_AUTH_CLASS ? process.env.VUE_APP_AUTH_CLASS : "login-register-bg";
    }
  },
  components: {
    VsPrism

  },
  mounted() {
    this.geolocation();
    helpersService.getIndustries().then(function (data) {
      this.industries = [];
      this.subIndustries = [];
      this.rawIndustries = data.industries;
      data.industries.forEach(obj => {
        this.industries.push({
          value: obj.id,
          text: obj.name
        });
      });

    }.bind(this));

    helpersService.getCountries().then(function (data) {
      this.countries = data.countries;
    }.bind(this));
  }
}
</script>
<style>

</style>

